import { jsx as _jsx } from "react/jsx-runtime";
import { LinkDescription } from './LinkDescription';
export function LinkListItem({ link }) {
    return (_jsx("div", { className: "space-y-3", children: _jsx(LinkDescription, { link: link }) }));
}
